import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RobotsMetaService } from '@tnq/shared/core';

// Marks the branch below it noindex/nofollow: only reachable via a session from the app.
export function noIndexGuard(): CanActivateFn {
  return () => {
    inject(RobotsMetaService).applyNoIndex();
    return true;
  };
}
